import { render } from "./PsihologiePage.vue?vue&type=template&id=76c0b390"
import script from "./PsihologiePage.vue?vue&type=script&lang=js"
export * from "./PsihologiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__